import { didMatchWithMask } from './didMatchWithMask';
import { isEmpty } from './isEmpty';
import { isPhoneEmpty } from './isPhoneEmpty';
import { ERequestDemandField } from '../../../constants/requestDemand';

type TValidators = {
  [key in ERequestDemandField]?: (value: string) => boolean;
};
const validators: TValidators = {
  [ERequestDemandField.EMAIL]: (value: string) =>
    !isEmpty(value as string) && didMatchWithMask(ERequestDemandField.EMAIL, value as string),
  [ERequestDemandField.PHONE]: (value: string) =>
    !isPhoneEmpty(value as string) && didMatchWithMask(ERequestDemandField.PHONE, value as string),
};

export const isValid = (name: keyof typeof validators, value: string): boolean => {
  const validator = validators[name];

  return validator ? validator(value) : !isEmpty(value);
};
